module.exports = {"search":{"btn":"搜尋"},"meta":{"lead":"路途還很遙遠，但路徑是自由的⋯⋯","license":"未另標註皆以 @:license.ccbysa4 釋出"},"graphics":{"title":"圖像章程"}};